import React, { useState } from "react";
import "./VectorInput.scss";
import { useNumberInputPart } from "./NumberInput";

export const VectorInput = ({ property }) => {
  const [, forceUpdate] = useState();
  const value = property.get() ?? property.createDefault();
  const dimensionLabels = property["dimensionLabels"] as string[];
  return (
    <div className="vector-input flex-row">
      {dimensionLabels.map((d, i) => {
        const { numberInput } = useNumberInputPart({
          value: value[i],
          setValue: (v) => {
            value[i] = v;
            forceUpdate(property.set(value));
            APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
          },
          step: property.step?.[i] ?? property.step,
          min: property.min?.[i] ?? property.min,
          max: property.max?.[i] ?? property.max,
          inputScale: property.inputScale?.[i] ?? property.inputScale,
          decimals: property.decimals,
          slider: false,
        });
        return (
          <div key={d} className="dimension flex-row">
            <label>{d}</label>
            {numberInput}
            &nbsp;
          </div>
        );
      })}
    </div>
  );
};
